<template>
  <v-container fluid class="px-0 py-0">
    <v-alert :value="empty" type="info">目前没有培训方案引用该课件</v-alert>
    <v-list two-line v-if="!empty && rules">
      <v-list-tile v-for="r in rules" :key="r.id">
        <v-list-tile-content>
          <v-list-tile-title>{{ r.name }}</v-list-tile-title>
          <v-list-tile-sub-title><label>机构</label><em>{{ r.orgName }} </em><label>状态</label><em>{{ r.status ? "激活" :
          "禁用" }}</em> <label>创建时间</label><em>{{ r.createTime | formatDatetime }}</em></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-container>
</template>
<script>
export default {
  name: "media-refers",
  props: { cfg: Object },
  data() {
    return {
      empty: false,
      rules: null,
    };
  },
  methods: {
    init() {
      let self = this,
        cid = self.cfg.coursewareId;
      self.$axios.get(`/home/admin/c/courseware/refers/${cid}`).then((r) => {
        r = r.data;
        if (!r || !r.message || r.message.length == 0) {
          self.empty = true;
          return;
        }

        let tHash = {},
          oHash = {};
        if (r.tenants && r.tenants.length > 0) {
          for (let t of r.tenants) {
            tHash[t.id] = t;
          }
        }
        if (r.orgs && r.orgs.length > 0) {
          for (let o of r.orgs) {
            oHash[o.id] = o;
          }
        }

        let rules = r.message;
        for (let rule of rules) {
          let t = tHash[rule.tenantId],
            o = oHash[rule.orgId];
          rule.orgName = (t ? t.name : "平台") + (o ? "-" + o.name : "");
        }
        self.rules = rules;
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
label {
  margin-left: 8px;
}

label::after {
  content: ":";
}

em {
  color: #0068b7;
}
</style>